import { useState, useEffect } from "react";
import axios from "axios";
import { isDevelopment } from "../utils/axiosConfig";

interface User {
  id: string;
  email: string;
  roles: string[];
}

const useAuth = () => {
  const [user, setUser] = useState<User>();
  const [userIdentifier, setUserIdentifier] = useState<string>();

  useEffect(() => {
    const fetchUser = async () => {
      if (isDevelopment) {
        console.log("Running in local environment, skipping user verification");
        setUser({
          id: "local_user",
          email: "local@example.com",
          roles: ["admin"],
        });
        setUserIdentifier("local@example.com");
        return;
      }

      try {
        const response = await axios.get("/verify-token");
        if (response.data.isValid) {
          setUser(response.data.user);
          setUserIdentifier(response.data.user.email);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    fetchUser();
  }, []);

  return { user, userIdentifier };
};

export default useAuth;
